export default __webpack_public_path__ + "static/media/room_bg_3.d005e10d.jpg";